import {BTooltip} from "bootstrap-vue";
import Back from "@@/core/components/shared/Back/Back";
import {
  BFormGroup,
  BFormTextarea,
  BFormInput,
} from "bootstrap-vue";

export default {
  name: "OrderHeader",
  props:{
    allowPrint:{
      type:Boolean,
      default:true
    },
    order: Object,
    allowEdit:{
      type:Boolean,
      default:true
    }
  },
  components: {
    BTooltip,  
    Back,
    BFormGroup,
    BFormTextarea,
    BFormInput,
  },
   mounted(){
    this.homeRequest();
  },
  data() {
    return {
      trackingCode: null,
      merchantUniqueId: null,
      orderDescription: null,
      password: null,
      type: null,
      amount: 0,
      admin: null,
    }
  },
  methods: {
     refundOrder() {
      this.$emit("refundOrderEmiter");
    },
    async homeRequest(){
      const response = await this.$axios.get('admin/home');
      this.admin = response.data.data.admin;
      
    },
      async submitData() {
      const data = {
        tracking_code: this.trackingCode,
        amount: this.amount,
        password: this.password,
        type: this.type,
      };
      try {
        const response = await this.$axios.post('admin/manual-digipay-refund', data);
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
      } catch (error) {  
        this.$root.notify(error)
      }
    },
    orderEdit() {
      this.$emit('order-edit')
    },
    printOrder() {
      this.$emit('print-order')
    }
  }
}
